module.exports = __webpack_public_path__ + "media/images/icon_exclamation-ee1372c3ce6891832f7680992c161dfc.svg";